export const ROW_ICON_SIZE = 14
export const ROW_ICON_STROKE_WIDTH = 1.5
export const ACTIONS_ICON_SIZE = 16
export const AVATAR_INITIALS_MAX_LENGTH = 1
